export enum RatingProgressProperty {
  id = 'id',
  value = 'value',
  color = 'color',
  requirements = 'requirements'
}
